/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon16Light = forwardRef('ArrowADownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 12.852a.914.914 0 0 0 .14-.116l4.006-4.005a.5.5 0 0 1 .708.707l-4.006 4.006a1.906 1.906 0 0 1-2.696 0L2.146 9.438a.5.5 0 1 1 .708-.707l4.005 4.005a.914.914 0 0 0 .141.116V2.5a.5.5 0 0 1 1 0v10.352Z" })));
});
